import TermsConditionsPt from './termsConditionsPt';
import TermsConditionsEs from './termsConditionsEs';
import TermsConditionsEn from './termsConditionsEn';

export default {
    'en': {
        howToArrive: "How to get there",
        install: "Install",
        about: "About",
        aboutIntro: "The following open source licensed software components are in use on this product:",
        logout: "Logout",
        settings: "Settings",
        appName: "Discover Manaus",
        welcome: "Hello,",
        welcomeText: "We would like to know more about you. Let's start?",
        continue: "Continue",
        enter: "Enter",
        highlight: "Highlights",
        seeAll: "See All",
        culturalPlaces: "Culture",
        naturalPlaces: "Nature",
        eventsNearby: "Events",
        events: "Events",
        places: "Places",
        ar: "Map",
        postCards: "Post cards",
        agreement: "By continuing, you agree to the",
        termsAndConditions: "Terms and conditions",
        termsAndConditionsText: TermsConditionsEn,
        hello: "Hello,",
        searchNotFound1: "Oops, I didn't find it.",
        searchNotFound2: "Let`s try again?",
        intro: "You will be able to find the attractions closest to you",
        permission: "Allow Discover Manaus",
        permission2: "access your location while you use the app",
        allow: "Allow",
        notAllow: "Not allow",
        jump: "Skip",
        next: "Next",
        back: "Back",
        explore: "Home",
        question1: "Where are you coming from?",
        question2: "How old are you?",
        question3: "What's your gender?",
        countryPlaceholder: "Enter your country",
        statePlaceholder: "Enter your state",
        searchPlaceholder: "What do you want to find?",
        age1: "Under 18",
        age2: "18 to 30",
        age3: "31 to 40",
        age4: "41 to 50",
        age5: "Over 50",
        gender1: "Male",
        gender2: "Female",
        gender3: "Others",
        ready: "Ready!",
        finishIntro: "Manaus welcomes you with open arms.",
        address: "Address",
        hour: "Hour",
        experiencesText: "Other locations near this",
        readMore: "Read more",
        readLess: "Read less",
        knowMore: "Know more",
        organizer: "Organizer",
        filterAll: "All",
        filterToday: "Today",
        filterTomorrow: "Tomorrow",
        filterWeek: "This week",
        filterNextWeek: "Next week",
        filterThisMonth: "This month",
        eventNotFound: "No events found",
        ok: "OK",
        cancel: "Cancel",
        confirmQuit: "Do you want to logout?",
        confirmQuitText: "All your data will be deleted",
        shareEvent: "Look what the App Descubra Manaus has found for you",
        landPageWelcome: "Our city always with you",
        landPageEvents: "Places and events you can't miss",
        landPageEventsDesc: "Explore attractions and collect unique postcards",
        landPageMap: "Try our interactive map",
        landPageMapDesc: "Project the sights in augmented reality and visit us anytime you want",
        landPageExperience: "Live an amazing experience",
        landPageExperienceDesc: "Take an augmented reality trip to Manaus history at the Museu da Cidade",
        landPageAudio: "Listen to\nexclusive contents\nabout our city",
        landPageAudioDesc: "Be delighted by what our hosts will tell you about the main sights",
        postCardTitle: "Always take our city with you",
        postCardDesc: "Explore our sights and get exclusive postcards to share with your friends",
        downloadApp: "Download our app",
        downloadAppSmall: "Download app",
        downloadAvaliable: "Available for Android and iOS.",
        downloadAppMessage: "Experience the AR technology",
        downloadAppButton: "Open"
    },
    'pt': {
        howToArrive: "Como chegar",
        install: "Instalar",
        about: "Sobre",
        aboutIntro: "Os seguintes componentes de software sob licenca de coigo aberto esta em uso nesse produto:",
        logout: "Sair",
        settings: "Configurações",
        appName: "Descubra Manaus",
        welcome: "Olá,",
        welcomeText: "Gostariamos de saber mais sobre você. Vamos começar?",
        continue: "Continuar",
        enter: "Entrar",
        highlight: "Destaques",
        seeAll: "Ver todos",
        culturalPlaces: "Cultura",
        naturalPlaces: "Natureza",
        eventsNearby: "Eventos",
        events: "Eventos",
        places: "Locais",
        ar: "Mapa",
        postCards: "Postais",
        agreement: "Ao continuar, você concorda com os",
        termsAndConditions: "Termos e condições",
        termsAndConditionsText: TermsConditionsPt,
        hello: "Olá,",
        searchNotFound1: "Ops, não encontrei.",
        searchNotFound2: "Vamos tentar de novo?",
        intro: "Você poderá encontrar as atrações mais próximas de você",
        permission: "Permitir que o Descubra Manaus",
        permission2: "acesse seu local enquanto você usa o app",
        allow: "Permitir",
        notAllow: "Não permitir",
        jump: "Pular",
        next: "Próximo",
        back: "Voltar",
        explore: "Home",
        question1: "Você está vindo de onde?",
        question2: "Qual sua idade?",
        question3: "Qual seu gênero?",
        countryPlaceholder: "Digite seu País",
        statePlaceholder: "Digite seu estado",
        searchPlaceholder: "O que deseja encontrar?",
        age1: "Menos de 18",
        age2: "18 a 30",
        age3: "31 a 40",
        age4: "41 a 50",
        age5: "Mais de 50",
        gender1: "Masculino",
        gender2: "Feminino",
        gender3: "Outros",
        ready: "Prontinho!",
        finishIntro: "Manaus te recebe te braços abertos.",
        address: "Endereço",
        hour: "Horário",
        experiencesText: "Outros locais próximos a este",
        readMore: "Ler mais",
        readLess: "Ler menos",
        knowMore: "Saiba mais",
        organizer: "Organizador",
        filterAll: "Todas",
        filterToday: "Hoje",
        filterTomorrow: "Amanhã",
        filterWeek: "Esta semana",
        filterNextWeek: "Próxima semana",
        filterThisMonth: "Este mês",
        eventNotFound: "Nenhum evento foi encontrado",
        ok: "OK",
        cancel: "Cancelar",
        confirmQuit: "Você quer sair?",
        confirmQuitText: "Todos os seus dados serão apagados!",
        shareEvent: "Confira essa dica que o App Descubra Manaus selecionou para você",
        landPageWelcome: "A nossa cidade sempre com você",
        landPageEvents: "Locais e eventos que você não pode perder",
        landPageEventsDesc: "Explore atrativos e colecione postais exclusivos",
        landPageMap: "Experimente\no mapa interativo",
        landPageMapDesc: "Projete os pontos turísticos em realidade aumentada e nos visite a hora que você quiser",
        landPageExperience: "Viva uma\nexperiência incrível",
        landPageExperienceDesc: "Faça uma viagem em realidade aumentada da história de Manaus no Museu da Cidade",
        landPageAudio: "Ouça conteúdos\ninéditos sobre\nnossa cidade",
        landPageAudioDesc: "Deixe-se encantar pelo que nossos anfitriões vão te contar sobre os principais pontos turísticos",
        postCardTitle: "Leve a nossa cidade sempre com você",
        postCardDesc: "Explore pontos turísticos e ganhe postais exclusivos para compartilhar com seus amigos",
        downloadApp: "Baixe nosso app",
        downloadAppSmall: "Baixar app",
        downloadAvaliable: "Disponível para Android e iOS.",
        downloadAppMessage: "Experimente a tecnologia AR",
        downloadAppButton: "Abrir"
    },
    'es': {
        howToArrive: "Cómo llegar",
        install: "Instalar",
        about: "Acerca",
        aboutIntro: "Los siguientes componentes de software con licencia de código abierto están en uso en este producto:",
        logout: "Cerrar sesión",
        settings: "Configuraciones",
        appName: "Descubrir Manaos",
        welcome: "Hola,",
        welcomeText: "Nos gustaría saber más sobre ti. ¿Comenzamos?",
        continue: "Continuar",
        enter: "Entrar",
        highlight: "Destacados",
        seeAll: "Ver todos",
        culturalPlaces: "Cultura",
        naturalPlaces: "Naturaleza",
        eventsNearby: "Eventos",
        events: "Eventos",
        places: "Lugares",
        ar: "Mapa",
        postCards: "Postales",
        agreement: "Al continuar, aceptas los",
        termsAndConditions: "Términos y Condiciones",
        termsAndConditionsText: TermsConditionsEs,
        hello: "Hola,",
        searchNotFound1: "Ops, no lo encontré.",
        searchNotFound2: "¿Lo intentamos de nuevo?",
        intro: "Podrás encontrar las atracciones más cercanas a ti",
        permission: "Permitir descubrir Manaus",
        permission2: "accede a tu ubicación mientras usas la aplicación",
        allow: "Permitir",
        notAllow: "No permitir",
        jump: "Saltar",
        next: "Siguiente",
        back: "Volver",
        explore: "Home",
        question1: "¿De dónde vienes?",
        question2: "¿Qué edad tienes?",
        question3: "¿Cuál es tu género?",
        countryPlaceholder: "Introduce tu país",
        statePlaceholder: "Introduce tu estado",
        searchPlaceholder: "¿Qué deseas encontrar?",
        age1: "Menos de 18",
        age2: "18 a 30",
        age3: "31 a 40",
        age4: "41 a 50",
        age5: "Más de 50",
        gender1: "Masculino",
        gender2: "Femenino",
        gender3: "Otros",
        ready: "¡Listo!",
        finishIntro: "Manaos te recibe de brazos abiertos",
        address: "Dirección",
        hour: "Tiempo",
        experiencesText: "Otros locales próximos a este",
        readMore: "Leer más",
        readLess: "Leer menos",
        knowMore: "Aprende más",
        organizer: "Organizador",
        filterAll: "Todo",
        filterToday: "Hoy",
        filterTomorrow: "Mañana",
        filterWeek: "Esta semana",
        filterNextWeek: "Próxima semana",
        filterThisMonth: "Este mes",
        eventNotFound: "No se encontraron eventos",
        ok: "OK",
        cancel: "Cancelar",
        confirmQuit: "¿Quieres salir?",
        confirmQuitText: "Todos tus datos serán eliminados",
        shareEvent: "Mira lo que la aplicación Discover Manaus ha seleccionado para ti",
        landPageWelcome: "Nuestra ciudad siempre contigo",
        landPageEvents: "Locales y eventos que no puedes perderte",
        landPageEventsDesc: "Explora atractivos y colecciona postales exclusivas",
        landPageMap: "Experimenta el mapa interactivo",
        landPageMapDesc: "Proyecta los puntos turísticos en realidad aumentada y visítanos cuando quieras.",
        landPageExperience: "Vive una experiencia increíble",
        landPageExperienceDesc: "Viaja en realidad aumentada a la historia de Manaos en el Museo de la Ciudad",
        landPageAudio: "Escucha contenidos\nexclusivos sobre\nnuestra ciudad",
        landPageAudioDesc: "Déjate sorprender por lo que nuestros\nanfitriones te contarán sobre\nlos principales puntos turísticos",
        postCardTitle: "Lleva siempre contigo nuestra ciudad",
        postCardDesc: "Explora puntos turísticos y gana postales exclusivas para compartir con tus amigos",
        downloadApp: "Baja nuestro app",
        downloadAppSmall: "Bajar app",
        downloadAvaliable: "Disponible para Android y iOS.",
        downloadAppMessage: "Experimenta la tecnología AR",
        downloadAppButton: "Abrir"
    }
}